module.exports = __webpack_public_path__ + "static/media/envira.79d08533.svg";